/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeadingStockHierarchyTrendCellResponse } from './LeadingStockHierarchyTrendCellResponse';
export type LeadingStockHierarchyTrendRowResponse = {
    depth: LeadingStockHierarchyTrendRowResponse.depth;
    level1: string;
    level2: string;
    level3: (string | null);
    cells: Array<LeadingStockHierarchyTrendCellResponse>;
};
export namespace LeadingStockHierarchyTrendRowResponse {
    export enum depth {
        '_2' = 2,
        '_3' = 3,
    }
}

